import ViewController from "core/views/view.controller";
import {BookingsFilter} from "../../services/bookings.service";
import {CustomersFilter} from "../../services/customers.service";
import {VehiclesFilter} from "../../services/vehicles.service";
import {WheelStoragesFilter} from "../../services/wheelstorages.service";

export default class SearchCtrl extends ViewController {
    static $inject = ['$scope', '$state', '$ionicScrollDelegate', '$element', 'settings', 'Bookings', 'Customers', 'Vehicles', 'WheelStorages'];

    static SearchType = {
        Bookings: "bookings",
        Customers: "customers",
        Vehicles: "vehicles",
        WheelStorages: "wheelstorages"
    };

    constructor() {
        super(...arguments);

        this.filter = null;
        this.datasource = null;
        this.result = null;
        this.hasMoreResults = true;

        // Bindings
        this.showTypeSelection = true;
        this.showTypeSelectionBookings = true;
        this.showTypeSelectionCustomers = true;
        this.showTypeSelectionCustomers = true;
        this.showTypeSelectionVehicles = true;
        this.showTypeSelectionWheelStorages = true;
        this.showSearchTerm = true;
        this.searchWithoutTerm = false;
        this.searchTerm = null;
        this.bookingsFilter = new BookingsFilter();
        this.customersFilter = new CustomersFilter();
        this.vehiclesFilter = new VehiclesFilter();
        this.wheelStoragesFilter = new WheelStoragesFilter();
    }

    $onChanges(changes) {

        if (changes.showTypeSelection && changes.showTypeSelection.currentValue == null) {
            this.showTypeSelection = true;
        }

        if (changes.showTypeSelectionBookings && changes.showTypeSelectionBookings.currentValue == null) {
            this.showTypeSelectionBookings = true;
        }

        if (changes.showTypeSelectionCustomers && changes.showTypeSelectionCustomers.currentValue == null) {
            this.showTypeSelectionCustomers = true;
        }

        if (changes.showTypeSelectionVehicles && changes.showTypeSelectionVehicles.currentValue == null) {
            this.showTypeSelectionVehicles = true;
        }

        if (changes.showTypeSelectionWheelStorages && changes.showTypeSelectionWheelStorages.currentValue == null) {
            this.showTypeSelectionWheelStorages = true;
        }

        if (changes.searchWithoutTerm && changes.searchWithoutTerm.currentValue == null) {
            this.searchWithoutTerm = false;
        }

        if (changes.showSearchTerm && changes.showSearchTerm.currentValue == null) {
            this.showSearchTerm = true;
        }

        if (changes.bookingsFilter && changes.bookingsFilter.currentValue == null) {
            this.bookingsFilter = new BookingsFilter();
        }

        if (changes.customersFilter && changes.customersFilter.currentValue == null) {
            this.customersFilter = new CustomersFilter();
        }

        if (changes.vehiclesFilter && changes.vehiclesFilter.currentValue == null) {
            this.vehiclesFilter = new VehiclesFilter();
        }

        if (changes.wheelStoragesFilter && changes.wheelStoragesFilter.currentValue == null) {
            this.wheelStoragesFilter = new WheelStoragesFilter();
        }

        if (this.searchType != null) {
            this.searchByType();
        }
    }

    searchByType() {
        if (this.searchType == SearchCtrl.SearchType.Bookings) {
            this.searchBookings();

        } else if (this.searchType == SearchCtrl.SearchType.Customers) {
            this.searchCustomers();

        } else if (this.searchType == SearchCtrl.SearchType.Vehicles) {
            this.searchVehicles();

        } else if (this.searchType == SearchCtrl.SearchType.WheelStorages) {
            this.searchWheelStorages();

        } else {
            throw "Unknown search type: " + this.searchType;
        }
    }

    search() {
        this.filter.first = 0;
        this.filter.search = this.searchTerm;
        this.result = null;

        if (this.searchTerm != null || this.searchWithoutTerm) {
            this.loadResults().then(() => {
                this.$ionicScrollDelegate.resize();
                this.$ionicScrollDelegate.scrollTop();
            });
        }
    }

    clearSearch() {
        this.searchTerm = null;
        this.hasMoreResults = false;

        if (!this.searchWithoutTerm) {
            this.result = null;
            this.$ionicScrollDelegate.resize();
            this.$ionicScrollDelegate.scrollTop();
        } else {
            this.search();
        }
    }

    searchBookings() {
        this.searchType = SearchCtrl.SearchType.Bookings;
        this.datasource = this.Bookings;
        this.filter = this.bookingsFilter;
        this.filter.branchId = this.settings.branch.id;
        this.filter.sortBy = 'startDate';
        this.filter.sortType = BookingsFilter.Sort.DESC;

        this.search();
    }

    searchCustomers() {
        this.searchType = SearchCtrl.SearchType.Customers;
        this.datasource = this.Customers;
        this.filter = this.customersFilter;

        this.search();
    }

    searchVehicles() {
        this.searchType = SearchCtrl.SearchType.Vehicles;
        this.datasource = this.Vehicles;
        this.filter = this.vehiclesFilter;

        this.search();
    }

    searchWheelStorages() {
        this.searchType = SearchCtrl.SearchType.WheelStorages;
        this.datasource = this.WheelStorages;
        this.filter = this.wheelStoragesFilter;
        this.filter.branchId = this.settings.branch.id;

        this.search();
    }

    selectBooking(booking) {
        if (this.onBookingSelected) {
            this.onBookingSelected({booking: booking});
        }
    }

    selectCustomer(customer) {
        if (this.onCustomerSelected) {
            this.onCustomerSelected({customer: customer});
        }
    }

    selectVehicle(vehicle) {
        if (this.onVehicleSelected) {
            this.onVehicleSelected({vehicle: vehicle});
        }
    }

    selectWheelStorage(wheelStorage) {
        if (this.onWheelStorageSelected) {
            this.onWheelStorageSelected({wheelStorage: wheelStorage});
        }
    }

    loadResults(append) {
        return this.datasource.find(this.filter)
            .then((result) => {
                if (append && this.result) {
                    this.result.data.push(...result.data);
                } else {
                    this.result = result;
                }

                this.filter.first += this.filter.max;
                this.hasMoreResults = this.result.data.length < this.result.total
            })
            .catch(() => {
                this.hasMoreResults = false;
            });
    }

    nextResults() {
        if (!this.hasMoreResults ||
            (this.searchTerm == null && !this.searchWithoutTerm)) {

            this.$scope.$broadcast('scroll.infiniteScrollComplete');
            return;
        }


        this.loadResults(true).finally(() => {
            this.$scope.$broadcast('scroll.infiniteScrollComplete');
        });
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/search/search.controller.js